import { useMutation, useQueryClient } from "@tanstack/react-query";
import { bdcApi, type BdcContactReviewRequest } from "../../../api/bdc.api";
import { useAppSelector } from "../../../redux/hooks";
import { getVaultActorAuthScope } from "../../../utils/vault/vaultActorSession";
import { vaultKeys } from "../queryKeys";

export function useBdcContactReview(folderId: string) {
  const queryClient = useQueryClient();
  const jwtToken = useAppSelector((state) => state.vault.jwtToken);
  const authScope = getVaultActorAuthScope(jwtToken);

  return useMutation({
    mutationFn: async ({
      requirementId,
      body,
    }: {
      requirementId: string;
      body: BdcContactReviewRequest;
    }) => {
      const response = await bdcApi.confirmContact(requirementId, body);
      if (response.reviewed !== true) {
        throw new Error("No se confirmó la revisión del contacto.");
      }
      return response;
    },
    onSuccess: async (_data, { requirementId }) => {
      // Only persisted folder data may satisfy the navigation prerequisites.
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: vaultKeys.folder(folderId, jwtToken ?? "anonymous"),
        }),
        queryClient.invalidateQueries({
          queryKey: vaultKeys.bdcStatus(requirementId, authScope),
        }),
      ]);
    },
  });
}
